export default __webpack_public_path__ + "static/media/giveindia-device-logo.499b3959.svg";